export default __webpack_public_path__ + "static/media/diversityFrame.5368ce4e.png";